import { resources } from "./environment-config";

export const getParameterByName = (name, url = window.location.href) => {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);

    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

/**
 * Determines the current environment configuration based on the URL parameters or hostname.
 */
export const getConfig = () => {
    const host = window.location.hostname;

    // If the url contains ?env=dev|test|acc|prod, use that.
    let env = getParameterByName('env');
    if (['dev', 'test', 'acc', 'prod'].includes(env)) {
        return resources[env];
    }

    // Otherwise, determine environment based on hostname.
    if (host.includes('localhost')) {
        return resources['dev'];
    }
    else if (host.includes('test.unfootprint.com')) {
        return resources['test'];
    }
    else if (host.includes('acc.unfootprint.com')) {
        return resources['acc'];
    }
    return resources['prod'];
};

export const config = getConfig();